import React, { Component } from 'react';
// import PropTypes from 'prop-types'
import { Button } from 'antd';
import styles from './PageContainer.module.css';

export const Container = props => {
  const { type } = props;
  if (type === undefined) {
    throw new Error('Undefined style <type> 3x3 or 2x3');
  }
  const style = styles['Container' + type];
  return <div className={[style, 'container'].join(' ')}>{props.children}</div>;
};

export class Title extends Component {
  render() {
    var button;
    if (this.props.button) {
      if (this.props.onClick === undefined) {
        throw new Error('Undefined callback function while button specified as true');
      }
      button = (
        <Button
          className={[styles.Button, this.props.className].join(' ')}
          size="large"
          type="primary"
          shape="circle"
          icon="plus"
          onClick={this.props.onClick}
        />
      );
    }

    return (
      <div className={styles.Title} style={this.props.style}>
        <p>
          <strong>{this.props.title}</strong>
        </p>
        {button}
        <hr />
      </div>
    );
  }
}

export class ExportTitle extends Component {
  render() {
    var button;
    if (this.props.button) {
      if (this.props.onClick === undefined) {
        throw new Error('Undefined callback function while button specified as true');
      }
      button = (
        <Button
          className={[styles.Button, this.props.className].join(' ')}
          size="large"
          type="primary"
          shape="circle"
          icon="file-excel"
          onClick={this.props.onClick}
        />
      );
    }

    return (
      <div className={styles.Title} style={this.props.style}>
        <p>
          <strong>{this.props.title}</strong>
        </p>
        {button}
        <hr />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/HOC/Layout/PageContainer.js